import { StyleSheet } from 'react-native';
import { List, Switch, Text, useTheme } from 'react-native-paper';

import { colorSemantic } from '@/theme';

interface SettingsToggleItemProps {
  readonly title: string;
  readonly description?: string;
  readonly value: boolean;
  readonly onValueChange: (value: boolean) => void;
  readonly disabled?: boolean;
}

const ToggleSwitch = ({
  value,
  onValueChange,
  disabled,
  accessibilityLabel,
}: Pick<SettingsToggleItemProps, 'value' | 'onValueChange' | 'disabled'> & {
  readonly accessibilityLabel: string;
}) => (
  <Switch
    accessibilityLabel={accessibilityLabel}
    value={value}
    onValueChange={onValueChange}
    disabled={disabled}
    color={colorSemantic.colorBgBrandBase}
  />
);

const ToggleDescription = ({ description }: { description?: string }) => {
  const theme = useTheme();

  if (!description) {
    return null;
  }

  return (
    <Text variant="bodySmall" style={{ color: theme.colors.outline }}>
      {description}
    </Text>
  );
};

export const SettingsToggleItem = ({
  title,
  description,
  value,
  onValueChange,
  disabled,
}: SettingsToggleItemProps) => {
  const accessibilityLabel = description ? `${title}, ${description}` : title;

  return (
    <List.Item
      title={title}
      titleNumberOfLines={2}
      style={styles.item}
      description={() => <ToggleDescription description={description} />}
      right={() => (
        <ToggleSwitch
          value={value}
          onValueChange={onValueChange}
          disabled={disabled}
          accessibilityLabel={accessibilityLabel}
        />
      )}
    />
  );
};

const styles = StyleSheet.create({
  item: {
    paddingHorizontal: 0,
  },
});
